import * as React from "react";

const SvgPresentationchartbar = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M8 12.5v-1M12 12.5v-3M16 12.5v-5M8 20.5l4-4 4 4M3 3.5h18M4 3.5h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-12Z" />
    </g>
  </svg>
);

export default SvgPresentationchartbar;
